import axios from 'axios';

import { SET_DASHBOARD_INIT_JSON } from './types';

import { API_KEY, AUTH_TOKEN, DASHBOARD_POST_URL } from '../envVariables';
import { isDevENV } from '../util/isDevENV';
import { updateErrorAndLoading } from './route_actions';

import localDashboardJson from '../data/dashboard-data.json';
import { isEmpty } from 'lodash';
import { getLocCoordinate } from '../util/geocoder';

/**
 * @module dashboard_action
 * @redux
 * @description These are redux actions creators related to dashboard.
 * @category Dashboard Page
 * @subcategory actions
 */


/**
 * @function
 * @name getDashboardJSON
 * @description It gets initial dashboard json from remote server.
 * @param {Function} [callback=null] - callback
 * @returns {Redux.Action} The generated action
 */
export const getDashboardJSON = (callback = null) => async (
  dispatch,
  getState
) => {
  try {
    dispatch(updateErrorAndLoading(undefined, true));

    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${AUTH_TOKEN}`,
      },
    };

    let inputParams = {
      apiKey: API_KEY,
      Authorization: `Bearer ${AUTH_TOKEN}`,
      user: getState().code_config.initAuth.user,
      verification: getState().code_config.initAuth.verification,
    };

    // console.log(inputParams);

    let response = {};
    if (isDevENV()) {
      await new Promise((resolve) => setTimeout(() => resolve(), 500));
      response.data = localDashboardJson;
    } else {
      response = await axios.post(
        DASHBOARD_POST_URL,
        { params: inputParams },
        axiosConfig
      );
    }

    console.log('before', response.data);
    if (response.data && !isEmpty(response.data)) {
      response.data = await getCoordinate(response.data);
    }
    console.log('after', response.data);

    dispatch({ type: SET_DASHBOARD_INIT_JSON, payload: response.data });

    if (callback) {
      callback();
    }

    dispatch(updateErrorAndLoading(undefined, undefined));
  } catch (err) {
    console.log(err);

    if (callback) {
      callback();
    }
    dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
  }
};


/**
 * @function
 * @name getCoordinate
 * @description If there is NO/empty property co-ordinates in shipment items, 
 * then it creates property co-ordinate object with properties 'lat' and 'lng' using the value in property 'city'.
 * @param {Object} dashboardObj - Full dashboard json
 * @returns {Object} - return full dashboard json with non-empty shipment items co-ordinates
 */
const getCoordinate = async (dashboardObj) => {
  if (
    !dashboardObj ||
    !Array.isArray(dashboardObj.shipments) ||
    dashboardObj.shipments.length === 0
  ) {
    return dashboardObj;
  }

  let tempShipmentArr = [];

  try {
    await Promise.all(
      dashboardObj.shipments.map(async (shipment) => {
        // if both co-ordinate is empty then get it from city
        if (isEmpty(shipment['co-ordinate'])) {
          // make request
          try {
            const locObj = await getLocCoordinate(shipment.city);
            let tempObj = {
              ...shipment,
              'co-ordinate': { lat: locObj.lat, lng: locObj.lng },
            };
            // console.log(tempObj);
            tempShipmentArr.push(tempObj);
          } catch (err) {
            console.log(err);
            tempShipmentArr.push(shipment);
          }
        } else {
          tempShipmentArr.push(shipment);
        }
      })
    );

    let tempDashboardObj = {
      ...dashboardObj,
      shipments: tempShipmentArr,
    };
    // console.log('tempDashboardObj: ', tempDashboardObj);

    return tempDashboardObj;
  } catch (err) {
    console.log(err);
    return dashboardObj;
  }
};
